<mf-left-menu
  [roleProvider]="loginService"
  [menuItems]="menuItems"
  (navigateTo)="navigateTo($event)" />
